import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
        paddingRight: 25
    },
    contentCard: {
        marginTop: 10,
        marginBottom: 10,
        alignItems: 'center'
    },
    textCoinGpx: {
        fontSize: 12,
        textAlign: 'right'
    },
    contentCoinBrl: {
        position: 'relative',
        marginVertical: 50,
        flexGrow: 1,
        marginLeft: 10
    },
    textCoinBrl: {
        fontSize: 12
    },
    textMyMoney: {
        position: 'relative',
        textAlign: 'center',
        top: -60,
        fontSize: 12,
        fontWeight: '500'
    },
    contentGraphic: {
        borderWidth: 4,
        width: 150,
        borderRadius: 120,
        height: 150,
        borderColor: '#196059',
        marginTop: 5
    },
    hrLineLeft: {
        height: 0.5,
        width: '80%',
        position: 'absolute',
        borderWidth: 0.5,
        borderColor: "#8E8E93",
        right: -11,
        top: 15
    },
    hrLineRight: {
        height: 0.5,
        width: '80%',
        position: 'relative',
        borderWidth: 0.5,
        marginBottom: 10,
        borderColor: "#8E8E93",
        marginLeft: -10,
    },
    contentCoinGpx: {
        position: 'relative',
        marginVertical: 50,
        flexGrow: 1,
        marginRight: 10
    },
    hr: {
        height: 0.5,
        marginTop: 10,
        backgroundColor: "#2C2C2E",
        opacity: 0.3,
    },
    hrGraphic: {
        height: 0.5,
        marginTop: 2,
        marginBottom: 2,
        backgroundColor: "#2C2C2E",
        opacity: 0.3,
    },
    contentPurchase: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 12,
        marginBottom: 12
    },
    textInfoPurchase: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    coinPurchase: {
        fontSize: 14,
        fontWeight: '400'
    },
    contentImgCoin: {
        alignItems: 'center',
        marginTop: 10
    },
    imgCoin: {
        width: 52,
        height: 52
    },
    nameCoin: {
        textAlign: 'center',
        marginTop: 20,
        fontWeight: 'bold',
        fontSize: 14
    },
    priceCoin: {
        textAlign: 'center',
        fontSize: 14
    },
    amountCoin: {
        textAlign: 'center',
        fontSize: 14,
        marginTop: 15
    },
    amountCoinBold: {
        fontWeight: 'bold'
    },
    btn: {
        width: '80%',
        backgroundColor: '#228C9A',
        padding: 15,
        borderRadius: 20,
        paddingHorizontal: 25,
        marginLeft: '10%',
        position: 'absolute',
        bottom: 20

    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: '500',
    },
    contentAmountCoins: {
        marginTop: -85,
        marginLeft: 20,
        width: 103
    },
    valueCoin: {
        fontSize: 11,
        textAlign: 'center'
    },
    titlePage: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: 15
    }
});

export default styles;
